import { Link } from 'react-router-dom';
import FaqAccordion from '@/components/feature/FaqAccordion';
import SectionHeading from '@/components/feature/SectionHeading';
import { faqs } from '@/mocks/faqs';

export default function FaqPreview() {
  const preview = faqs.slice(0, 5);

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="先回答你最想问的"
              desc="这些问题来自读者留言与社区反诈宣讲现场提问，我们尽量给出可以直接照着做的答案。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
            >
              查看全部问题
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={preview} />
          </div>
        </div>
      </div>
    </section>
  );
}